"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFileSize = function (sizeInBytes) {
    var thresh = 1000;
    if (Math.abs(sizeInBytes) < thresh) {
        return sizeInBytes + ' B';
    }
    var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var u = -1;
    do {
        sizeInBytes /= thresh;
        ++u;
    } while (Math.abs(sizeInBytes) >= thresh && u < units.length - 1);
    return sizeInBytes.toFixed(1) + ' ' + units[u];
};
